<template>
  <div>
    <v-alert
      prominent
      text
      dense
      type="info"
    >
      Для добавления обучения, найдите вакансию, переходите в ее карточку и там будет раздел обучения.
    </v-alert>
    <v-tabs
      v-model="orgViewActiveTab"
      background-color="transparent"
      color="basil"
      grow
      show-arrows
    >
      <v-tab
        v-for="item in getTabDataCollection"
        :key="item.id"
        :href="'#' + item.id"
        @click="onTabChange(item)"
      >
        <span style="position: relative;">
          <span
            v-if="getOrganization && getTabStat(item.id) !== null"
            style="
          display: inline-block;background-color: #E53935; color: whitesmoke; text-align: center;
          position: absolute; top: -16px; right: -8px; font-size: 0.8em; padding: 0 4px; border-radius: 12px"
          >{{ getTabStat(item.id) }}</span>
          {{ item.title }}
        </span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="orgViewActiveTab">
      <v-tab-item
        :value="tabData.ORGANIZATION_COMMON_INFORMATION_TAB"
      >
        <v-card
          class="mx-auto"
          outlined
        >
          <v-toolbar
            v-if="showEditButton"
            dense
          >
            <v-spacer />
            <v-btn
              outlined
              rounded
              color="info"
              @click="goToEdit"
            >
              <v-icon class="mr-1">
                mdi-pencil
              </v-icon>
              <span>Редактировать</span>
            </v-btn>
          </v-toolbar>

          <div v-if="!isEditMode && getOrganization && getOrganization.id">
            <v-row
              no-gutters
              class="px-4"
            >
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
              >
                <v-toolbar
                  flat
                  color="white"
                  class="mx-0 px-0"
                >
                  <v-avatar
                    v-if="getOrganization.logo && getOrganization.logo.path"
                    left
                  >
                    <v-img :src="getOrganization.logo.path" />
                  </v-avatar>
                  <!--                  <v-toolbar-title>Общий</v-toolbar-title>-->
                  <div>
                    <v-btn
                      color="success"
                      text
                    >
                      {{ `Баланс:` }}
                    </v-btn>

                    <v-btn
                      color="success"
                      rounded
                      outlined
                    >
                      {{ `${getTotalAmount} ₽` }}
                    </v-btn>
                  </div>
                  <div>
                    <v-btn
                      color="secondary"
                      text
                    >
                      {{ `Офферы:` }}
                    </v-btn>

                    <v-btn
                      color="secondary"
                      rounded
                      outlined
                    >
                      {{ `${getTotalOffers}` }}
                    </v-btn>
                  </div>
                  <v-spacer />
                  <v-btn
                    :disabled="!canRefillBalance"
                    color="success"
                    rounded
                    :title="!canRefillBalance ? 'У вас нет прав на пополнение баланса' : 'Пополнение баланса'"
                    small
                    @click="onOpenRefillAmountModal"
                  >
                    <v-icon class="mr-1">
                      fa-plus
                    </v-icon>
                    <span style="font-size: 2em"> ₽</span>
                  </v-btn>
                </v-toolbar>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="4"
              >
                <v-checkbox
                  v-model="getOrganization.isActive"
                  :disabled="true"
                  label="Активная"
                />
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="4"
              >
                <v-checkbox
                  v-model="getOrganization.hasAgencyContract"
                  label="Агентский Договор"
                  :disabled="true"
                />
              </v-col>
              <!--              <v-col-->
              <!--                cols="12"-->
              <!--                class="px-3 py-3"-->
              <!--                :sm="12"-->
              <!--                :md="4"-->
              <!--              >-->
              <!--                <v-checkbox-->
              <!--                  v-model="getOrganization.isFinanceLess"-->
              <!--                  label="безлимитный баланс"-->
              <!--                  :disabled="true"-->
              <!--                />-->
              <!--              </v-col>-->

              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="4"
              >
                <div class="wbd-label-text">
                  {{ 'Финансовая модель' }}
                </div>
                <div>{{ getOrganization.financialModel.label }}</div>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Название' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.title }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'КПП' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.kpp }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'ИНН' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.inn }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Юридический адрес' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.legalAddress }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Бухгалтер' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.accountant }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Корреспондентский счет' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.correspondentAccount }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Ген. директор' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.director }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Регион' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.region.title }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Настройки перерыва' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.lunchSettingString }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Максимальная длительности смены в часах' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.maxRelayDuration }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Вводный инструктаж по охране труда' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <WBDFileUploader
                    v-if="getOrganization && getOrganization.workSafetyInstruction"
                    :mime-types="'application/pdf'"
                    icon
                    :alias="'laborer-work-instruction'"
                    :label="'Добавить вводный инструктаж по охране труда'"
                    :model="getOrganization.workSafetyInstruction"
                    disabled
                    @onFileDeleted="() => {}"
                    @onFileSaved="() => {}"
                  />
                </v-col>
              </v-col>
            </v-row>
            <v-row
              v-if="getOrganization.root && getOrganization.root.id"
              no-gutters
              class="px-4"
            >
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
              >
                <v-card-title class="headline">
                  Главный админ
                </v-card-title>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Имя' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.root.firstName }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Фамилия' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.root.lastName }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Отчество' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.root.middleName }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Почта' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.root.email }}</div>
                </v-col>
              </v-col>
              <v-col
                cols="12"
                class="px-3 py-3"
                :sm="12"
                :md="6"
              >
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div class="wbd-label-text">
                    {{ 'Телефон' }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 my-0"
                  :sm="12"
                >
                  <div>{{ getOrganization.root.telephone }}</div>
                </v-col>
              </v-col>
            </v-row>
          </div>
          <OrganizationFrom
            v-if="isEditMode"
            :model="getOrganization"
            :financialModelEditable="financialModelEditable"
          />

          <v-expansion-panels
            v-if="getOrganization && getOrganization.id"
            :disabled="!hasSignatoryAuthority"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>Другой подписант</v-expansion-panel-header>
              <v-expansion-panel-content>
                <OrganizationSignatoryAuthority
                  v-if="hasSignatoryAuthority"
                  :model="signatoryAuthority"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-card-actions v-if="showEditButton">
            <v-spacer />
            <v-btn
              outlined
              rounded
              color="info"
              @click="goToEdit"
            >
              <v-icon class="mr-1">
                mdi-pencil
              </v-icon>
              <span>Редактировать</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>

      <v-tab-item
        v-if="orgViewActiveTab === tabData.ORGANIZATION_OFFICE_LIST_TAB"
        :value="tabData.ORGANIZATION_OFFICE_LIST_TAB"
      >
        <OrganizationOfficeTabComponent
          :data="officeList"
          :organization="getOrganization"
          :office-options.sync="officeOptions"
          :tableLoading="tabLoading"
          @reloadOfficeList="reloadOfficeList"
          @onOfficeOptionChange="onOfficeOptionChange"
          @onFilterBtnClicked="getOfficeList"
        />
      </v-tab-item>
      <v-tab-item
        v-if="orgViewActiveTab === tabData.ORGANIZATION_VACANCY_LIST_TAB"
        :value="tabData.ORGANIZATION_VACANCY_LIST_TAB"
      >
        <OrganizationVacancyTabComponent
          :data="vacancyList"
          :list-options="userListOptions"
          :tableLoading="tabLoading"
          :vacancy-counter="getVacancyCounter"
        />
      </v-tab-item>
      <v-tab-item
        v-if="orgViewActiveTab === tabData.ORGANIZATION_USER_TAB"
        :value="tabData.ORGANIZATION_USER_TAB"
      >
        <OrganizationUserTabComponent
          :data="userList"
          :officeList="officeList"
          :user-list-options="userListOptions"
          :tableLoading="tabLoading"
          @reloadUserList="reloadUserList"
          @onOfficeOptionChange="onUserListOptionChange"
        />
      </v-tab-item>
      <v-tab-item
        :value="tabData.ORGANIZATION_BLACK_LIST"
      >
        <BlackListTabComponent
          v-if="getOrganization && getOrganization.id"
          :organization="getOrganization"
          :tableLoading="tabLoading"
        />
      </v-tab-item>
      <v-tab-item
        :value="tabData.ORGANIZATION_LEGAL_ENTITY_LIST"
      >
        <LegaEntityTabComponent
          :tableLoading="tabLoading"
          :paginatorTotal="serverLegalEntityListNumber"
          :data="legalEntityList"
          :legalEntityListOptions="{
            page: 1,
            itemsPerPage: footerProps.itemsPerPageOptions[2],
          }"
          @reloadLegalEntityList="reloadLegalEntityList"
        />
      </v-tab-item>
      <v-tab-item
        :value="tabData.ORGANIZATION_PRIVATE_STAFF_LIST"
      >
        <v-card class="mx-auto">
          <v-card-title>Тип исполнителей организации</v-card-title>
          <v-alert
            v-if="!hasWorkerType"
            type="warning"
            prominent
            dense
          >
            Этот доступен для установки только
            один раз и после выбора изменен быть не может.
            Выбрать можно один вариант (Самозанятые, физические лица или обе категории), в зависимости
            от выбранного варианта, можно приглашать исполнителей
          </v-alert>
          <v-card-text>
            <v-select
              v-model="workerType"
              :disabled="!!hasWorkerType"
              :items="workerTypeList"
              label="Тип моих исполнителей"
              :item-text="'title'"
              :item-value="'id'"
              return-object
              required
            />
          </v-card-text>
          <v-card-actions v-if="!hasWorkerType">
            <v-spacer />
            <v-btn
              text
            >
              Отмена
            </v-btn>
            <v-btn
              :disabled="!workerType"
              text
              color="success"
              @click="onOpenConfirmModal"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
        <WBDInstitutionStaffManager
          v-if="hasWorkerType && orgViewActiveTab === tabData.ORGANIZATION_PRIVATE_STAFF_LIST"
          @reloadOfficeView="requestModel($route.params.id)"
        />
      </v-tab-item>
    </v-tabs-items>
    <ConfirmModal
      v-if="showConfirmModal"
      :displaySelf="!!showConfirmModal"
      title="Выбор тип исполнителей"
      :message="saveWorkerTypeConfirmationMessage"
      @onCancelCallback="onCloseConfirmModal"
      @onSuccessCallback="onConfirmModalConfirmed"
    />
    <OrganizationRefillAmount
      v-if="showRefillAmountModal"
      :displaySelf="!!showRefillAmountModal"
      :organization="getOrganization"
      @onCloseRefillAmountModal="onCloseRefillAmountModal"
      @onAmountRefilled="onAmountRefilled"
    />
  </div>
</template>

<script>
import OfficeListUtil from '@/utils/office-list-filter-util'
import OrganizationSignatoryAuthority from '@/views/organization/organization-signatory-authority'
const ORGANIZATION_COMMON_INFORMATION_TAB = 'organization-common-information'
const ORGANIZATION_OFFICE_LIST_TAB = 'organization-office-list-tab'
const ORGANIZATION_VACANCY_LIST_TAB = 'organization-vacancy-tab'
const ORGANIZATION_OFFERS_TAB = 'organization-offer-list-tab'
const ORGANIZATION_RELAY_LIST_TAB = 'organization-relay-list-tab'
const ORGANIZATION_USER_TAB = 'organization-user-tab'
const ORGANIZATION_BLACK_LIST = 'organization-black-list-tab'
const ORGANIZATION_LEGAL_ENTITY_LIST = 'legal-entity-tab'
const ORGANIZATION_PRIVATE_STAFF_LIST = 'private-staff'
import ConfirmModal from '@/components/common/confirm-modal'

import OrganizationFrom from '@/views/organization/organization-form.vue'
import OrganizationRefillAmount from '@/views/organization/refill-amount-modal'
import OrganizationVacancyTabComponent from '@/views/organization/vacancy-tab'
import OrganizationUserTabComponent from '@/views/organization/user-tab'
import OrganizationOfficeTabComponent from '@/views/organization/office-tab'
import BlackListTabComponent from '@/views/organization/black-list'
import LegaEntityTabComponent from '@/views/organization/legal-entity-tab'
import { USER_CREATE_ROUTE_NAME } from '@/router/client'
import ListMixin from '@/mixins/list-mixin.vue'
import DictionaryMixin from '@/mixins/dictionaryMixin'
import WBDInstitutionStaffManager from '@/views/organization/institution-staff'

export const ALIAS_WORKER_TYPE_LEGAL_PERSON = 'wt-legal-person'
export const ALIAS_WORKER_TYPE_RU_SELF_EMPLOYED = 'wt-self-employed'
export const ALIAS_WORKER_TYPE_ALL = 'wt-all'
export const ORGANIZATION_EDIT_ID = 'new'
import AppUserAccessManager from '@/utils/user-roles-util'
import WBDFileUploader from '@/components/common/files/file-uploader.vue'

export const LABEL_WORKER_TYPE_RU_WORKER = 'Физическое лицо'
export const LABEL_WORKER_TYPE_RU_SELF_EMPLOYED = 'СМЗ'
export const LABEL_WORKER_TYPE_ALL = 'Обе категории'
export const FINANCIAL_MODEL_STANDARD = 'finance-standard'
export const FINANCIAL_MODEL_FULL_MONEY = 'finance-full-money'
export const FINANCIAL_MODEL_FINANCE_LESS = 'finance-less'

export const LABEL_FINANCIAL_MODEL_STANDARD = 'Стандартная (ДС и офферы)'
export const LABEL_FINANCIAL_MODEL_FULL_MONEY = 'Только ДС (Без офферов)'
export const LABEL_FINANCIAL_MODEL_FINANCE_LESS = 'Без финансов (Без ДС и без Офферов)'

export default {
  name: 'WBDOrganizationViewPage',
  components: {
    WBDFileUploader,
    OrganizationRefillAmount,
    OrganizationSignatoryAuthority,
    ConfirmModal,
    BlackListTabComponent,
    LegaEntityTabComponent,
    OrganizationOfficeTabComponent,
    OrganizationFrom,
    WBDInstitutionStaffManager,
    OrganizationUserTabComponent,
    OrganizationVacancyTabComponent
  },
  mixins: [ListMixin, DictionaryMixin],
  data: () => ({
    financialModelEditable: true,
    showConfirmModal: false,
    showRefillAmountModal: false,
    currentId: null,
    workerType: null,
    workerTypeList: [
      { id: ALIAS_WORKER_TYPE_LEGAL_PERSON, title: LABEL_WORKER_TYPE_RU_WORKER },
      { id: ALIAS_WORKER_TYPE_RU_SELF_EMPLOYED, title: LABEL_WORKER_TYPE_RU_SELF_EMPLOYED },
      { id: ALIAS_WORKER_TYPE_ALL, title: LABEL_WORKER_TYPE_ALL },
    ],
    vacancyList: [],
    officeList: [],
    officeOptions: {},
    userListOptions: {},
    userList: [],
    legalEntityList: [],
    tabLoading: false,
    serverLegalEntityListNumber: 0,
    orgViewActiveTab: null,
    AddAdminRoute: USER_CREATE_ROUTE_NAME,
    tabData: {
      ORGANIZATION_COMMON_INFORMATION_TAB,
      ORGANIZATION_OFFICE_LIST_TAB,
      ORGANIZATION_VACANCY_LIST_TAB,
      ORGANIZATION_OFFERS_TAB,
      ORGANIZATION_RELAY_LIST_TAB,
      ORGANIZATION_USER_TAB,
      ORGANIZATION_BLACK_LIST,
      ORGANIZATION_LEGAL_ENTITY_LIST,
      ORGANIZATION_PRIVATE_STAFF_LIST,
    },
  }),
  computed: {
    getTabDataCollection () {
      if (this.isEditMode) {
        return [
          { title: 'Общая информация', id: ORGANIZATION_COMMON_INFORMATION_TAB },
        ]
      }

      return [
        { title: 'Общая информация', id: ORGANIZATION_COMMON_INFORMATION_TAB },
        { title: 'Объекты', id: ORGANIZATION_OFFICE_LIST_TAB },
        { title: 'Вакансии', id: ORGANIZATION_VACANCY_LIST_TAB },
        { title: 'Пользователи', id: ORGANIZATION_USER_TAB },
        { title: 'Черный список', id: ORGANIZATION_BLACK_LIST },
        { title: 'Юр. лица', id: ORGANIZATION_LEGAL_ENTITY_LIST },
        { title: 'Мои исполнители', id: ORGANIZATION_PRIVATE_STAFF_LIST },
        // { title: 'Офферы', id: ORGANIZATION_OFFERS_TAB },
        // { title: 'Смены', id: ORGANIZATION_RELAY_LIST_TAB },
      ]
    },
    showEditButton () {
      return !this.isEditMode && this.getOrganization && this.getOrganization.id
    },
    isEditMode () {
      return this.currentId === ORGANIZATION_EDIT_ID
    },
    getVacancyCounter () {
      if (!this.getOrganization || !this.getOrganization.stats) {
        return 250
      }
      const stats = this.getOrganization.stats

      return stats.vacancyCertificationCounter || 250
    },
    canRefillBalance () {
      return AppUserAccessManager.canRefillOrganizationAmount(this.getMe)
    },
    getTotalAmount () {
      if (!this.getOrganization || !this.getOrganization.amount) {
        return 0
      }

      return new Intl.NumberFormat().format(this.getOrganization.amount)
    },
    getMe () {
      const me = this.$store.state.user.me
      return me
    },
    getTotalOffers () {
      if (!this.getOrganization || !this.getOrganization.availableOffersNumber) {
        return 0
      }

      return this.getOrganization.availableOffersNumber
    },
    hasSignatoryAuthority () {
      return this.getOrganization.organizationSignatoryAuthority &&
          this.getOrganization.organizationSignatoryAuthority.id
    },
    signatoryAuthority () {
      return this.getOrganization.organizationSignatoryAuthority
    },
    saveWorkerTypeConfirmationMessage () {
      return 'Вы уверены, что выбрали верный тип работников организации, ВСЕ ' +
          'личные исполнители будут приглашенны в систему с выбранными типом, ' +
          'будьте внимательные при выборе параметра'
    },
    getOrganization () {
      const organization = this.$store.getters['organization/getStoreModel'](
        this.$route.params.id,
      )
      const self = this
      self.workerType = organization ? organization.workerType : undefined


      if (organization && organization.financialModel) {
        self.financialModelEditable = organization.financialModel.editable
      }

      return {
        ...organization,
        lunchSettingString: this.getLunchSettingString(organization)
      }
    },
    hasOrganization () {
      return this.getOrganization && this.getOrganization.id
    },
    hasWorkerType () {
      return this.hasOrganization && this.getOrganization.workerType
    }
  },
  watch: {
    orgViewActiveTab: async function (val) {
      this.vacancyList = []
      this.officeList = []
      switch (val) {
      case ORGANIZATION_OFFICE_LIST_TAB:
        this.officeOptions = {
          page: 1,
          itemsPerPage: this.footerProps.itemsPerPageOptions[2],
        }

        await this.getOfficeList()

        break
      case ORGANIZATION_VACANCY_LIST_TAB:
        this.userListOptions = {
          page: 1,
          itemsPerPage: this.footerProps.itemsPerPageOptions[2],
        }

        break
      case ORGANIZATION_USER_TAB:
        this.userListOptions = {
          page: 1,
          itemsPerPage: this.footerProps.itemsPerPageOptions[2],
        }
        await this.reloadUserList()
        break
      case ORGANIZATION_BLACK_LIST:
        await this.onBlackListTabClicked()
        break
      case ORGANIZATION_LEGAL_ENTITY_LIST:
        // await this.onBlackListTabClicked()
        await this.reloadLegalEntityList()
        break
      case ORGANIZATION_PRIVATE_STAFF_LIST:
        break
      }
      this.$forceUpdate()
    }
  },
  created () {
    this.currentBaHandler(this.$route.query.current_tab)
    this.requestModel(this.$route.params.id)
    this.currentId = this.$route.params.id
    this.loadDictionaries()
  },
  mounted () {
    this.$nextTick(() => {
      this.updateChatSize()
    })
  },
  methods: {
    getLunchSettingString (organization) {
      if (!organization || !organization.lunchSetting) {
        return ''
      }
      const str = []
      const { lunchSetting } = organization
      for (const [key, value] of Object.entries(lunchSetting)) {
        const min = parseInt(key, 10) % 60
        const hours = (parseInt(key, 10) - min) / 60
        const hourStr = String(hours).padStart(2, '0')
        const minStr = String(min).padStart(2, '0')
        str.push(`${hourStr}ч ${minStr}мин : ${value}`)
      }

      return str.join('; ')
    },
    async onOfficeOptionChange (options) {
      if (options.page !== this.officeOptions.page || this.officeOptions.itemsPerPage !== options.itemsPerPage) {
        this.officeOptions = options
        await this.reloadOfficeList()
      }
    },
    async onUserListOptionChange (options) {
      if (options.page !== this.userListOptions.page || this.userListOptions.itemsPerPage !== options.itemsPerPage) {
        this.userListOptions = options
        await this.reloadUserList(true)
      }
    },
    async reloadOfficeList () {
      this.tabLoading = true
      const officeList = await this.$store.dispatch(
        'organization/getOfficeList',
        {
          id: this.$route.params.id,
          params: {
            'page[number]': this.officeOptions.page,
            'page[size]': this.officeOptions.itemsPerPage
          }
        }
      )
      this.officeList = officeList.data
      this.tabLoading = false
    },
    async reloadLegalEntityList () {
      this.tabLoading = true
      const legalEntityList = await this.$store.dispatch(
        'organization/getLegalEntityList',
        {
          params: {
            'organization[id]': this.$route.params.id,
          }
        }
      )
      this.legalEntityList = legalEntityList.data
      if (legalEntityList.headers['x-total-count']) {
        this.serverLegalEntityListNumber = parseInt(legalEntityList.headers['x-total-count'], 10)
      } else {
        this.serverLegalEntityListNumber = this.footerProps.itemsPerPageOptions[2]
      }

      this.tabLoading = false
    },
    async reloadUserList () {
      this.tabLoading = true
      const userList = await this.$store.dispatch(
        'organization/getClientList',
        {
          params: {
            'organization[id]': this.$route.params.id,
            'page[number]': this.userListOptions.page,
            'page[size]': this.userListOptions.itemsPerPage
          }
        }
      )
      this.userList = userList.data

      this.tabLoading = false
    },
    async onBlackListTabClicked () {
    },
    goToEdit () {
      this.currentId = ORGANIZATION_EDIT_ID
    },
    async getOfficeList (filters) {
      this.tabLoading = true
      try {
        let params = {
          'page[number]': this.officeOptions.page,
          'page[size]': this.officeOptions.itemsPerPage
        }
        if (filters) {
          params = {
            ...params,
            ...OfficeListUtil.getOfficeListParamsFromFilter(filters)
          }
        }

        const officeList = await this.$store.dispatch(
          'organization/getOfficeList',
          {
            id: this.$route.params.id,
            params
          },

        )
        this.officeList = officeList.data
        this.tabLoading = false
      } catch (error) {
        console.log(error)
      }
      this.tabLoading = false
    },
    async loadDictionaries () {
      this.regionList = await this.getDictionaries('REGION_PATH')
    },
    async requestModel (id) {
      if (id !== 'new') {
        await this.$store.dispatch('organization/getModel', { id })
      }
    },
    async onOpenConfirmModal () {
      this.showConfirmModal = true
    },
    async onCloseConfirmModal () {
      this.showConfirmModal = false
    },
    async onOpenRefillAmountModal () {
      this.showRefillAmountModal = true
    },
    async onCloseRefillAmountModal () {
      this.showRefillAmountModal = false
    },
    async onAmountRefilled () {
      this.showRefillAmountModal = false
      await this.requestModel(this.$route.params.id)
    },
    async onConfirmModalConfirmed (item, saveCallback) {
      if (!this.workerType || !this.workerType.id) {
        return
      }
      try {
        this.showPageLoader()

        await this.$store.dispatch(
          'organization/setWorkerType',
          { id: this.getOrganization.id, workerType: this.workerType.id }
        )
        this.hidePageLoader()
        await this.requestModel(this.$route.params.id)
        this.showConfirmModal = false
        this.showSuccessNotification('Тип исполнителей успешно установлен!', 'success')
      } catch (error) {
        console.log(error)
        this.hidePageLoader()
        this.showErrorNotification('Не удалось установить Тип исполнителей', 'error')
      }
    },
    getTabStat (tabId) {
      if (!this.getOrganization || !this.getOrganization.stats) {
        return 0
      }

      const stats = this.getOrganization.stats

      switch (tabId) {
      case ORGANIZATION_COMMON_INFORMATION_TAB:
        return null
      case ORGANIZATION_OFFICE_LIST_TAB:
        return stats.officeCounter || 0
      case ORGANIZATION_VACANCY_LIST_TAB:
        // return stats.vacancyCertificationCounter || 0
        return stats.vacancyCounter || 0
      case ORGANIZATION_USER_TAB:
        return stats.userCounter || 0
      case ORGANIZATION_BLACK_LIST:
        return stats.blackListCounter || 0
      case ORGANIZATION_PRIVATE_STAFF_LIST:
        return stats.remoteWorkerCounter || 0
      }

      return null
    },
    onTabChange (data) {
      this.updateRouteData(data.id)
    },
    async updateRouteData (activeTab) {
      this.$router.replace({
        ...this.$router.currentRoute,
        query: { current_tab: activeTab }

      })
    },
    currentBaHandler () {
      const routeQuery = this.$route.query

      if (!routeQuery) {
        return
      }
      const queryTab = routeQuery.current_tab
      this.orgViewActiveTab = queryTab || ORGANIZATION_COMMON_INFORMATION_TAB
    }
  },
}
</script>
<style lang="scss" scoped>
    .office-item {
        cursor: pointer;
    }
</style>
